let menuToggle = document.getElementById('menu-toggle');
let slideIn = document.getElementById('nav-slide-in');
let slideInClose = document.getElementById('nav-slide-in-close');
let slideInOverlay = document.getElementById('header__slide-in__overlay');
let body = document.getElementsByTagName('body');

let hasSub = slideIn.getElementsByClassName('has-sub');

menuToggle.addEventListener('click', function() {
    body[0].classList.add('nav-open');
    slideIn.classList.add('open');
})

slideInClose.addEventListener('click', function() {
    slideIn.classList.remove('open');
    body[0].classList.remove('nav-open');
})

slideInOverlay.addEventListener('click', function() {
    slideIn.classList.remove('open');
    body[0].classList.remove('nav-open');
})

for (let i = 0; i < hasSub.length; i++) {
    let subMenu = hasSub[i].getElementsByClassName('sub-menu');
    hasSub[i].addEventListener('click', function() {
        if (hasSub[i].classList.contains('active')) {
            hasSub[i].classList.remove('active');
            subMenu[0].style.maxHeight = null;
        } else {
            hasSub[i].classList.add('active');
            subMenu[0].style.maxHeight = subMenu[0].scrollHeight + "px";
        }
    })
}